module.exports = __webpack_public_path__ + "static/media/domain_logo_Saudi Arabia.cb38326c.svg";